import { defineCustomElement, getAttribute, getBooleanAttribute, getReactEventHandler, getTargetByAttribute, NectaryElement, updateAttribute, updateBooleanAttribute } from '../utils';
const templateHTML = '<style>:host{display:block;outline:0}#wrapper{display:flex;flex-direction:row;width:100%;box-sizing:border-box;position:relative;z-index:0}</style><div id="wrapper"><slot></slot></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-segmented-control', class extends NectaryElement {
  #$slot;
  #controller = null;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.#$slot = shadowRoot.querySelector('slot');
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const {
      signal
    } = this.#controller;
    const options = {
      signal
    };
    this.role = 'tablist';
    this.#$slot.addEventListener('slotchange', this.#onSlotChange, options);
    this.#$slot.addEventListener('click', this.#onOptionClick, options);
    this.#$slot.addEventListener('keydown', this.#onOptionKeydown, options);
    this.addEventListener('-change', this.#onChangeReactHandler);
  }
  disconnectedCallback() {
    this.#controller.abort();
    this.#controller = null;
  }
  static get observedAttributes() {
    return ['value'];
  }
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'value':
        {
          this.#onValueChange(newVal);
          break;
        }
    }
  }
  set value(value) {
    updateAttribute(this, 'value', value);
  }
  get value() {
    return getAttribute(this, 'value', '');
  }
  #onSlotChange = () => {
    this.#onValueChange(this.value);
  };
  #onOptionClick = e => {
    const target = getTargetByAttribute(e, 'value');
    if (target === null || getBooleanAttribute(target, 'disabled')) {
      return;
    }
    const value = getAttribute(target, 'value', '');
    this.dispatchEvent(new CustomEvent('-change', {
      detail: value
    }));
  };
  #onOptionKeydown = e => {
    switch (e.code) {
      case 'Space':
      case 'Enter':
        {
          e.preventDefault();
          const target = getTargetByAttribute(e, 'value');
          if (target !== null) {
            target.click();
          }
        }
    }
  };
  #onValueChange(value) {
    for (const $option of this.#$slot.assignedElements()) {
      const isChecked = !getBooleanAttribute($option, 'disabled') && value === getAttribute($option, 'value', '');
      updateBooleanAttribute($option, 'data-checked', isChecked);
    }
  }
  #onChangeReactHandler = e => {
    getReactEventHandler(this, 'on-change')?.(e);
  };
});